<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`field_${_uid}`"
    :rules="rules"
    :custom-messages="{
      required: $t('validation.namedFieldIsMandatory', {
        field: localize(this.item.label)
      })
    }"
    mode="eager"
  >
    <v-textarea
      v-model="fieldValue"
      outlined
      flat
      hide-details="auto"
      :label="fieldLabel"
      :name="fieldLabel"
      :error-messages="errors"
      :class="{ 'label--multi-line': multiLineLabel }"
    ></v-textarea>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    multiLineLabel() {
      return this.fieldLabel.length > 20 && this.$vuetify.breakpoint.mdAndUp;
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'required';
      }

      return '';
    }
  },

  components: {
    ValidationProvider
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input.v-textarea.v-text-field--outlined {
  .v-input__slot {
    .v-label {
      white-space: normal;
    }
  }
}

::v-deep
  .v-input.v-textarea.label--multi-line
  .v-input__slot
  .v-label.v-label--active {
  height: auto;
  top: 5px;
  background-color: #fff;
  z-index: 2;
}
</style>
